import React from 'react'
import HeaderV2 from './HeaderV2'
import FooterV2 from './FooterV2'
import './styles.css'

function LegalFrame({children}) {
  return (
    <div className="hlm-page">
      <HeaderV2 />
      <main className="hlm-legal">{children}</main>
      <FooterV2 />
    </div>
  )
}

export default LegalFrame
